'use client';

import { useEffect, useState } from 'react';

import { CloseIcon } from './icons';

export type HunterNote = {
  id: string;
  prefix: string;
  body: string;
};

/**
 * Hunter Note toast — top-right, max 1 at a time, auto-dismiss 6 s.
 * PR1 ships the rendering primitive; in PR2 it will subscribe to a
 * client store fed by /api/hub/hunter-note.
 */
export function HunterNoteToast({ note }: { note: HunterNote | null }) {
  const [active, setActive] = useState<HunterNote | null>(note);

  useEffect(() => {
    setActive(note);
  }, [note]);

  useEffect(() => {
    if (!active) return;
    const timer = window.setTimeout(() => setActive(null), 6000);
    return () => window.clearTimeout(timer);
  }, [active]);

  if (!active) return null;

  return (
    <div className="hunter-toast" role="status" aria-live="polite">
      <span className="ht-icon">H</span>
      <div className="ht-body">
        <b>{active.prefix}</b>
        {active.body}
      </div>
      <button
        type="button"
        className="ht-close"
        aria-label="Dismiss Hunter note"
        onClick={() => setActive(null)}
      >
        {CloseIcon}
      </button>
    </div>
  );
}
